import './InstallationCard.scss';
import React, { MouseEventHandler } from 'react';
import { Installation } from 'types/Installation';
import { getDisplayDateFromTimestamp } from 'functions/deviceStatusUtils';

interface InstallationCardProps {
  installation: Installation,
  onClick?: MouseEventHandler | undefined
}

const InstallationCard: React.FC<InstallationCardProps> = ({ installation, onClick }) => {
  return (
    <div className="installation-card">
      <div className="installation-card__header" onClick={onClick}>
        <div className="installation-card__header-title">
          <div className="installation-card__header-serial">
            {installation.id} 
          </div>
          <span style={{ fontSize: 'smaller' }}>
            {installation.deviceId}
          </span>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: 'smaller' }}>
          <span style={{ whiteSpace: 'nowrap', flex: '1 1 auto', minWidth: 'min-content', marginRight: '5px' }}>
            {installation.dateFailed ? 'Failed' : installation.dateCompleted ? 'Completed' : '<Unknown Status>'} @{' '}
            {installation.dateFailed ? getDisplayDateFromTimestamp(installation.dateFailed) : 
            installation.dateCompleted ? getDisplayDateFromTimestamp(installation.dateCompleted) : ''}
          </span>
          <span style={{ whiteSpace: 'nowrap', flex: '1 1 auto', minWidth: 'min-content' }}>
            By {installation.audit?.createdBy}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InstallationCard;